import { useCallback, useState } from 'react';

export interface ModalState<TData> {
  isModalOpen: boolean;
  openModal: (initialData?: TData) => void;
  closeModal: () => void;
  data?: TData;
}

export const useModalState = <TData>(): ModalState<TData> => {
  const [data, setData] = useState<TData>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = useCallback(
    (d?: TData) => {
      setData(d);
      setIsModalOpen(true);
    },
    [setIsModalOpen]
  );
  const closeModal = useCallback(() => {
    setData(undefined);
    setIsModalOpen(false);
  }, [setIsModalOpen]);

  return { isModalOpen, openModal, closeModal, data };
};
